import {
  JobTypeLResponse,
  JobCountResponse,
  JobCountDetailResponse,
} from '@doda/api-client/aspida/@types';

/**
 * DisplayOccupationLは表示用の大分類職業データを定義するインターフェースです。
 */
export interface DisplayOccupationL {
  /** 大分類職業ID */
  id: string;
  /** 大分類職業名 */
  name: string;
  /** 検索職業タイプID */
  searchJobTypeId: string;
  /** 検索職業タイプ名 */
  searchJobTypeName: string;
  /** サブネーム */
  subName: string;
  /** 中分類職業リスト */
  jobTypeMList: OccupationM[];
  /** 求人数 */
  jobCount: number;
}

/**
 * 中分類職業データを定義するインターフェース
 */
interface OccupationM {
  /** 中分類職業ID */
  id: string;
  /** 中分類職業名 */
  name: string;
  /** 検索職業タイプID */
  searchJobTypeId: string;
  /** 検索職業タイプ名 */
  searchJobTypeName: string;
  /** 小分類職業リスト */
  jobTypeSList: OccupationS[];
  /** 求人数 */
  jobCount: number;
}

/**
 * 小分類職業データを定義するインターフェース
 */
interface OccupationS {
  /** 小分類職業ID */
  id: string;
  /** 小分類職業名 */
  name: string;
  /** 検索職業タイプID */
  searchJobTypeId: string;
  /** 検索職業タイプ名 */
  searchJobTypeName: string;
  /** 求人数 */
  jobCount: number;
}

/**
 * 表示用職業データを作成する関数
 *
 * @param {JobTypeLResponse[]} jobType - 大分類職業データのリスト
 * @param {JobCountResponse} jobCount - 求人数のレスポンス
 * @returns {DisplayOccupationL[]} - 表示用職業データのリスト
 */
export const createOccupationDisplayData = (
  jobType: JobTypeLResponse[],
  jobCount: JobCountResponse
): DisplayOccupationL[] => {
  return jobType.map((occupationL) => ({
    ...occupationL,
    jobCount: findJobCount(
      jobCount.searchJobTypeLList,
      occupationL.searchJobTypeId
    ),
    jobTypeMList: occupationL.jobTypeMList.map((occupationM) => ({
      ...occupationM,
      jobCount: findJobCount(
        jobCount.searchJobTypeMList,
        occupationM.searchJobTypeId
      ),
      jobTypeSList: occupationM.jobTypeSList.map((occupationS) => ({
        ...occupationS,
        jobCount: findJobCount(
          jobCount.searchJobTypeSList,
          occupationS.searchJobTypeId
        ),
      })),
    })),
  }));
};

/**
 * 求人数を見つける関数
 *
 * @param {JobCountDetailResponse[] | undefined} countList - 求人数の詳細リスト
 * @param {string} id - 探しているID
 * @returns {number} - 見つかった求人件数
 */
export const findJobCount = (
  countList: JobCountDetailResponse[] | undefined,
  id: string
): number => countList?.find((i) => id === i.id)?.count ?? 0;
